import UserContext from "../../Contexts/UserContext";
import React from "react";
import { useEffect, useRef, useState, useContext } from "react";
import {
  Avatar,
  Loading,
  getDefaultUser,
  PageHeader,
  Modal,
} from "wup-module1-base";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../../Services/Auth/AuthService";
import { Card } from "react-bootstrap";
import { DateHelpers } from "../../Helpers/Date/DateHelpers";

const SessionModal = (data) => {
  const navigate = useNavigate();
  const [selectLoad, setSelectLoad] = useState(false);
  const [seconds, setSeconds] = useState(300);
  const { user, setUser } = useContext(UserContext);
  let refreshTokenPromise;

  const logout = () => {
    AuthService.logout()
      .then((response) => {
        setUser(getDefaultUser());
        navigate("/login");
      })
      .catch((error) => {})
      .finally(() => {
        sessionStorage.clear();
        localStorage.clear();
      });
  };
  const isCurrentPathPublic = () => {
    const currentPath = window.location.pathname;
    return (
      currentPath.includes("/login") ||
      currentPath.includes("/forgotPassword") ||
      currentPath.includes("/resetPassword") ||
      currentPath.includes("/set-password")
    );
  };

  const refreshToken = () => {
    AuthService.refreshToken()
      .then((refreshResponse) => {
        refreshTokenPromise = null;
        return refreshResponse;
      })
      .catch((e) => {
        if (!isCurrentPathPublic()) navigate("/login");
      });
  };

  function onCancel() {
    data.setOpenSessionModal(false);
    logout();
  }

  function onConfirm() {
    data.setOpenSessionModal(false);
    refreshToken();
  }

  function parseDate(dateString) {
    let [datePart, timePart] = dateString.split(", ");
    let [day, month, year] = datePart.split(".").map(Number);
    let [hours, minutes, seconds] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  function calculateTime() {
    let currentSession = JSON.parse(sessionStorage.getItem("sessionDate"));
    let currentDate = new Date().toLocaleString();
    let parsedCurrentSession = parseDate(currentSession);
    let parsedCurrentDate = parseDate(currentDate);
    let timeDifference = parsedCurrentDate - parsedCurrentSession;
    if (
      Math.floor(timeDifference / 1000) < 300 &&
      Math.floor(timeDifference / 1000) > 0
    ) {
      return 300 - Math.floor(timeDifference / 1000);
    } else {
      logout();
    }
  }

  useEffect(() => {
    let interval = null;

    if (data.sessionModalIsOpen) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds !== 0) {
      clearInterval(interval);
    }

    if (seconds === 0) {
      clearInterval(interval);
      onCancel();
    }

    return () => clearInterval(interval);
  }, [data.sessionModalIsOpen, seconds]);

  const resetTimer = () => {
    setSeconds(calculateTime());
  };

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  useEffect(() => {
    if (!!data.sessionModalIsOpen) {
      resetTimer();
    }
  }, [data.sessionModalIsOpen]);

  return (
    <>
      {selectLoad ? (
        <Loading className="px-1 mr-3 nav-link" size="sm" />
      ) : (
        <>
          <Modal
            show={data.sessionModalIsOpen}
            size={"default"}
            onCancel={onCancel}
            onConfirm={onConfirm}
            enforceFocus={true}
            confirmButtonText="Tak"
            className={"session-modal"}
          >
            <Card.Body>
              <PageHeader content="Twoja sesja wygasa" />
              <div>
                Za 5 min zostaniesz wylogowany, czy chcesz przedłużyć sesję?
              </div>

              <div className="stopwatch">
                <div className="time">
                  {`Automatyczne wylogowanie nastąpi za: `}
                  {minutes}:{remainingSeconds < 10 ? "0" : ""}
                  {remainingSeconds}
                </div>
              </div>
            </Card.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default SessionModal;
